import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';
import {
  Layout,
  InternalLinkButton,
  routes,
  pageTypes,
  siteDescription,
  AdLeaderboard
} from 'gatsby-theme-apollo';
import {
  CoverTitle,
  GameCover,
  GameGrid,
  GameThumbnail,
  GameThumbnailName,
  GameLink
} from '../templates/games/game-covers';
import GameContent from '../templates/page/content';
import PostPreviewCards from '../templates/cards/post-preview-card';
import TierListPreviewCards from '../templates/cards/tier-list-preview-card';
import Section from '../templates/layout/section';
import Footer from '../templates/page/footer';
import { Hero, HeroImg } from '../templates/layout/hero';
import { generateTierListPreviews } from '../util/strip-data';
import GameSearch from '../templates/games/game-search';

const IndexPage = ({ data, location }) => {
  const pageType = pageTypes.HOME;

  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              logoURI
              heroImageURI
            }
          }
          cms {
            games(sort: "name:ASC") {
              name
              id
              heroURI
            }

            tierlists(sort: "lastPublish:DESC", where: { featured_eq: "true" }, limit: 3) {
              title
              featured
              author {
                name
              }
              description
              tierJSON
              createdAt
              lastPublish
              permalink
              game {
                name
              }
            }

            posts(
              sort: "createdAt:DESC"
              where: { featured_eq: "true", page_ne: "true", publish_eq: "true" }
              limit: 6
            ) {
              title
              author {
                name
                id
              }
              subtitle
              publish
              createdAt
              updatedAt
              publishedDate
              headerURI
              featured
              games {
                name
              }
              headerImage {
                url
              }
            }
          }
        }
      `}
      render={staticData => {
        const { cms, site } = staticData;

        const { heroImageURI: heroURI } = site.siteMetadata;
        const { games, tierlists, posts } = cms;

        const featuredTierListPreviews = generateTierListPreviews(tierlists);

        return (
          <Layout location={location} pageType={pageType}>
            <GameContent hideMobile noHeader>
              <Hero>
                <HeroImg src={heroURI} title='GamerHub splash image' />
                <div style={{ flex: 1, minWidth: 220, maxWidth: 600, padding: '0px 15px' }}>
                  <h2 style={{ margin: '15px 0px' }}>{siteDescription}</h2>
                  <InternalLinkButton primary to={routes.TierListMaker()}>
                    <span role="img" aria-label="Create">
                      ✍
                    </span>
                    Tier List Maker
                  </InternalLinkButton>
                </div>
                <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
              </Hero>
              <Section title="Game Wikis" h1 fullWidth flushContent>
                <GameSearch games={staticData.cms.games} targetPageType="game_hub" />
                <GameGrid>
                  {games.map(game => {
                    return (
                      <Link key={game.name + "Wiki"} to={routes.GameHub(game.name)} title={game.name + " Wiki"}>
                        <GameCover>
                          <div>
                            <img
                              src={game.heroURI}
                              alt={game.name + " cover icon"}
                            />
                          </div>
                          <CoverTitle>{game.name}</CoverTitle>
                        </GameCover>
                      </Link>
                    );
                  })}
                </GameGrid>
              </Section>

              <Section title="Tier Lists" fullWidth flushContent>
                <GameGrid>
                  {games.map(node => {
                    return (
                      <GameLink to={routes.TierListHub(node.name)} key={node.name}>
                        <GameThumbnail src={node.heroURI} alt={`${node.name} cover icon`} />
                        <GameThumbnailName>{node.name} Tier Lists</GameThumbnailName>
                      </GameLink>
                    );
                  })}
                </GameGrid>
              </Section>

              <Section title="Featured Tier Lists" fullWidth>
                <TierListPreviewCards tierListPreviews={featuredTierListPreviews} showGameName />
                <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-bottom"} />
              </Section>

              <Section
                title="Recent Guides"
                linkTarget={routes.PostHub()}
                linkText={'All Guides'}
                fullWidth
              >
                <PostPreviewCards postPreviews={posts} />
              </Section>
              <Footer />
            </GameContent>
          </Layout>
        );
      }}
    />
  );
};

export default IndexPage;
